/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/raid_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16.646 6.646a.5.5 0 01.707 0l2 2A.502.502 0 0119 9.5a.502.502 0 01-.354-.146l-2-2a.502.502 0 010-.708zm-1.292 17.708a.502.502 0 01-.708 0l-2-2a.5.5 0 01.707-.707l2 2a.5.5 0 01.001.707zm7.5-1.5c-.192.193-.459.275-.767.275-1.085 0-2.687-1.021-3.44-1.775l-9.5-9.5.707-.707 9.5 9.5c.979.979 2.52 1.592 2.824 1.478.067-.256-.554-1.792-1.531-2.771l-9.5-9.5.707-.707 9.5 9.5c.968.968 2.375 3.332 1.5 4.207z"/>'
  }
})
